import React from 'react';
import { DimensionFieldProps } from './typings';

// Placeholder dimension field - will be updated once we have requirements for basic model for `dimenions`
const BaseDimensionField: React.FC<DimensionFieldProps> = (props) => {
  return <></>;
};

export default BaseDimensionField;
